module.exports = "https://cdn.thelire.com/ins/resource/lh_special_three_follower@3x.840639f38dde124fc4c8500b3e1ecc5d.png";